import Modal from '@/components/v2/common/Modal';
import useCategoryConditions from '@/lib/use-category-conditions';
import { useProductPageContext } from '@/components/v2/product/hooks/useProductPageContext';
import { ConditionModalProps } from './types';
import Header from './Header';
import Content from './Content';

const ConditionModal = ({
  showModal,
  setShowModal,
  activeCondition,
}: Readonly<ConditionModalProps>) => {
  const {
    selectedSkuDetails: { categoryId },
  } = useProductPageContext();

  const conditionsContent = useCategoryConditions(categoryId);

  return (
    <Modal
      isOpen={showModal}
      onClose={() => setShowModal(false)}
      width="md:max-w-[750px]"
    >
      <Header setShowModal={setShowModal} />
      <Content
        activeCondition={activeCondition}
        conditionsContent={conditionsContent}
      />
    </Modal>
  );
};

export default ConditionModal;
